import React from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

//pages
import Maintenance from "../pages/pages/maintenance/Maintenance";

//login
import Login from "../pages/authentication/Login";
import ForgetPasswordPage from "../pages/authentication/ForgetPassword";
import Logout from "../pages/authentication/Logout";
import Register from "../pages/authentication/Register";
import CreatePassword from "../pages/authentication/CreatePassword";
import NewPasswordPage from "../pages/authentication/NewPasswordPage"

// User profile
import Audience from "../pages/pages/audience/Audience";
import CustomerGrowth from "../pages/pages/customerGrowth/CustomerGrowth";
import ThirdPartyPlatformsAccount from "../pages/pages/customerGrowth/ThirdPartyPlatforms/ThirdPartPlatformsAccount";
import Profile from "../pages/pages/profile/Profile";
import TargetAudience from "../pages/pages/customerGrowth/TargetAudience/TargetAudience";

import SalesGrowth from "../pages/pages/salesGrowth/SalesGrowth";
import Landing from "../pages/pages/landing/Landing";
import CampaignManagement from "../pages/pages/salesGrowth/CampaignManagement";

import AImeeAnalytics from "../pages/pages/aimeeAnalytics/AImeeAnalytics";

// Vskor 
import VskorAdmin from "../pages/pages/vskor/VskorAdmin";

//Company
import CompanyAdmin from "../pages/pages/admin/CompanyAdmin";
import CompanyDetail from "../pages/pages/admin/CompanyDetail";

// Admin Analytics
import AdminAnalytics from "../pages/pages/admin/analytics/AdminAnalytics";

import OohLocationAudience from "../pages/pages/customerGrowth/OOH/OohLocationAudience";
import ConsolePage from "../pages/pages/assistant/pages/ConsolePage";

import NotificationApplications from "../pages/pages/salesGrowth/NotificationApplications";

import BitcoinAnalytics from "../pages/pages/bitcoin/BitcoinAnalytics";

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: <Landing />,
    hideIfHasFeature: "BITCOIN"
  },
  {
    path: "/profile",
    component: <Profile />,
    requiredSubscription: "USER_ANALYTIC",
    requiredFeature: "userAnalytic",
  },
  {
    path: "/sales-growth/campaigns",
    component: <CampaignManagement />,
    requiredSubscription: "SALES_GROWTH",
    requiredFeature: "salesGrowth",
  },
  {
    path: "/sales-growth/current",
    component: <SalesGrowth />,
    requiredSubscription: "SALES_GROWTH",
    requiredFeature: "salesGrowth",
  },
  {
    path: "/sales-growth/notification-applications",
    component: <NotificationApplications />,
    requiredSubscription: "SALES_GROWTH",
    requiredFeature: "salesGrowth",
  },
  {
    path: "/audience",
    component: <Audience />,
    requiredSubscription: "AUDIENCE",
    requiredFeature: "audience",
  },
  {
    path: "/target-audience",
    component: <TargetAudience />,
    requiredSubscription: "TARGET_AUDIENCE",
    requiredFeature: "targetAudience",
  },
  {
    path: "/aimee-analytics",
    component: <AImeeAnalytics />,
  },
  {
    path: "/vskor-admin",
    component: <VskorAdmin />,
  },
  {
    path: "/company-admin",
    component: <CompanyAdmin />,
  },
  {
    path: "/company-detail/:clientId",
    component: <CompanyDetail />,
  },
  {
    path: "/ooh-location-audience",
    component: <OohLocationAudience />,
    requiredSubscription: "OOH",
    requiredFeature: "oohLocationAudience",
  },
  {
    path: "/third-party-platforms",
    component: <CustomerGrowth />,
    requiredSubscription: "DMP_DSP_EXPORT",
    requiredFeature: "dmpDspExport",
  },
  {
    path: "/third-party-platforms-accounts",
    component: <ThirdPartyPlatformsAccount />,
    requiredSubscription: "DMP_DSP_EXPORT",
    requiredFeature: "dmpDspExport",
  },
  {
    path: "/admin-analytics",
    component: <AdminAnalytics />,
  },
  {
    path: "/aimee-assistant",
    component: <ConsolePage />
  },
  {
    path: "/bitcoin-analytics",
    component: <BitcoinAnalytics />,
    requiredSubscription: "BITCOIN",
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/bitcoin-analytics" />,
  },
  {
    path: "*",
    component: <Navigate to="/bitcoin-analytics" />,
  },
];



const publicRoutes = [
  // authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/forget-password-verify", component: <NewPasswordPage /> },
  //{ path: "/register", component: <Register /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/register-password", component: <CreatePassword /> },


];

export { authProtectedRoutes, publicRoutes };
